var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0714 8.3892C16.0714 7.8307 16.0258 7.2722 15.9347 6.7251H8.20215V9.88233H12.6321C12.4499 10.8968 11.8577 11.8086 10.9922 12.3785V14.4301H13.6343C15.1831 13.0054 16.0714 10.8968 16.0714 8.3892Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20248 16.4134C10.4118 16.4134 12.2794 15.6839 13.6346 14.4302L10.9926 12.3785C10.2523 12.88 9.30713 13.165 8.20248 13.165C6.0615 13.165 4.25078 11.7174 3.60166 9.77979H0.879883V11.8998C2.26924 14.6695 5.10489 16.4134 8.20248 16.4134Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60208 9.77985C3.26038 8.76543 3.26038 7.65983 3.60208 6.63401V4.52539H0.879876C-0.293292 6.83918 -0.293292 9.57469 0.879876 11.8885L3.60208 9.77985Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20248 3.24891C9.37546 3.22612 10.5029 3.67064 11.3456 4.47989L13.6916 2.13191C12.1997 0.741363 10.241 -0.0222999 8.20248 0.00049605C5.10489 0.00049605 2.26924 1.75578 0.879883 4.52549L3.60166 6.64551C4.25078 4.69646 6.0615 3.24891 8.20248 3.24891Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.fde133a6a729b8241a1f23a670e4acfd.svg";
export { ForwardRef as ReactComponent };